var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment-question 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6143 1.69147C8.05783 1.52225 5.55653 2.45514 3.75265 4.26133C1.94877 6.06826 1.01594 8.57044 1.19324 11.1278C1.51693 15.8026 5.64555 19.3281 10.7968 19.3281H15.1497C17.178 19.3281 18.8281 17.6779 18.8281 15.6495V10.7496C18.8274 5.98292 15.2196 2.00488 10.6143 1.69147ZM9.92792 15.6495C9.31878 15.6495 8.8244 15.1551 8.8244 14.546C8.8244 13.9368 9.31878 13.4424 9.92792 13.4424C10.5371 13.4424 11.0314 13.9368 11.0314 14.546C11.0314 15.1551 10.5371 15.6495 9.92792 15.6495ZM11.3463 10.8585C10.963 11.0697 10.6636 11.5582 10.6636 11.9709C10.6636 12.3778 10.334 12.7067 9.92792 12.7067C9.52182 12.7067 9.19224 12.3778 9.19224 11.9709C9.19224 11.0255 9.78593 10.0382 10.6364 9.56955C11.1977 9.26054 11.4875 8.64695 11.375 8.00614C11.2735 7.42787 10.7791 6.93346 10.2009 6.83193C9.75577 6.75321 9.32098 6.86799 8.98184 7.15197C8.64784 7.43302 8.45656 7.84355 8.45656 8.2791C8.45656 8.68595 8.12698 9.01481 7.72089 9.01481C7.3148 9.01481 6.98521 8.68595 6.98521 8.2791C6.98521 7.40727 7.3685 6.58621 8.03576 6.02559C8.70375 5.46497 9.58583 5.23248 10.4554 5.38257C11.642 5.59078 12.6168 6.56487 12.825 7.75232C13.0442 9.00231 12.4506 10.2508 11.347 10.8593L11.3463 10.8585Z",
    fill: "url(#paint0_linear_83_14741)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_14741",
    x1: 10,
    y1: 1.67188,
    x2: 10,
    y2: 20.0562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.3b0abbfd391f3063e007cc56965ba564.svg";
export { ForwardRef as ReactComponent };